// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"826":"index","998":"chunk-vendors"}[chunkId] || chunkId) + "." + {"826":"cf0a8463","973":"034b3e37","998":"bff5c464"}[chunkId] + ".css";
};